module.exports = __webpack_public_path__ + "img/doctor_bg.16257927.png";